// extracted by mini-css-extract-plugin
module.exports = {"type-button":"api-reference-field-type_type-button__1x8OA"};